import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import Tooltip, { Orientation } from '@dojo/widgets/tooltip';
import { formatAriaProperties } from '@dojo/widgets/common/util';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Keys } from '@holmescorp/common';
import { AudioMiddleware } from '../middleware/audio';

import css from '../css/audio.m.css';

export interface PlayButtonProperties {
	title: string;
	key: string;
	trackNumber: number;
	audio: AudioMiddleware;
}

interface PlayButtonIcache {
	ttPlay: boolean;
	currentTrack: number;
}

const icache = createICacheMiddleware<PlayButtonIcache>();
const factory = create({
	icache,
	theme
}).properties<PlayButtonProperties>();

export const PlayButton = factory(({ properties, middleware: { icache, theme } }) => {
	const { title, key, trackNumber, audio } = properties();
	const themeCss = theme.classes(css);
	let timerId: number;

	return v(
		'div',
		{
			classes: [themeCss.topicAudio]
		},
		[
			w(
				Tooltip,
				{
					open: icache.getOrSet('ttPlay', false),
					orientation: Orientation.bottom
				},
				[
					{
						content: v(
							'span',
							{
								id: `play-tooltip-${key}`,
								classes: [themeCss.audioTooltip],
								onmouseover: () => clearTimeout(timerId),
								onmouseout: () => icache.set('ttPlay', false),
								onkeydown: (event: KeyboardEvent) => {
									switch (event.key) {
										case Keys.Escape:
											icache.set('ttPlay', false);
											break;
									}
								}
							},
							[`Play ${title}`]
						),
						trigger: v(
							'div',
							{
								key: `${key}-audio`,
								xqa: `audio ${key}`,
								classes: [themeCss.audioButton],
								role: 'button',
								tabIndex: 0,
								...formatAriaProperties({
									label: `Play ${title} audio`,
									describedby: `play-tooltip-${key}`
								}),
								onclick: () => {
									audio.change_track(trackNumber);
								},
								onmouseover: () => {
									icache.set('ttPlay', true);
								},
								onmouseout: () => {
									timerId = setTimeout(() => {
										icache.set('ttPlay', false);
									}, 500);
								},
								onfocus: () => {
									icache.set('ttPlay', true);
								},
								onblur: () => {
									icache.set('ttPlay', false);
								},
								onkeydown: (event: KeyboardEvent) => {
									switch (event.key) {
										case Keys.Enter:
										case Keys.Space:
										case Keys.Spacebar:
											audio.change_track(trackNumber);
											break;
										case Keys.Escape:
											icache.set('ttPlay', false);
											break;
									}
								}
							},
							[v('i', { classes: ['fa-solid', 'fa-circle-play'] })]
						)
					}
				]
			)
		]
	);
});

export default PlayButton;
